import { CommonModule,formatDate } from '@angular/common';
import { Component, OnInit,inject, ViewChild,signal,Inject,LOCALE_ID, AfterViewInit } from '@angular/core';
import { ReactiveFormsModule,FormsModule, FormBuilder, FormGroup } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { PiasLayoutComponent } from '../../../shared/components/pias-layout/pias-layout.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { CampaignService } from '../campaign-service/campaign-service';
import { SnackbarService } from '../../../shared/services/snackbar/snackbar.service';
import { Router } from '@angular/router';
import { MatTimepickerModule } from '@angular/material/timepicker';
import {provideNativeDateAdapter} from '@angular/material/core';
import { ViewRecipientsPayload } from '../schedule-campaign-model/schedule-campaign';
@Component({
  selector: 'app-campaign-detail',
  providers: [provideNativeDateAdapter()],
  imports: [
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatTabsModule,
    MatPaginatorModule,
    MatButtonModule,
    MatIconModule,
    CommonModule,
    ReactiveFormsModule,
    PiasLayoutComponent,
    MatDatepickerModule,
    MatTimepickerModule,
    FormsModule
  ],
  templateUrl: './campaign-detail.component.html',
  styleUrl: './campaign-detail.component.scss'
})
export class CampaignDetailComponent implements AfterViewInit, OnInit {
  private campaignService = inject(CampaignService);
  private router = inject(Router);
  private snackBarService = inject(SnackbarService);
  setSprinner = signal(false);
   
  @ViewChild('paginator') paginator!: MatPaginator;

  protected campaign: any = {
    name: '',
    status: 'draft',
    createdDate: '',
    createdBy: '',
    channel: 'Email',
    subject: '',
    total_count: 0,
    success_count: 0,
    failure_count: 0,
    message_template: ''
  };

  protected contactsDs = new MatTableDataSource<any>();
  protected allRecipients: any[] = [];
  protected fb: FormBuilder;
  protected scheduleForm!: FormGroup;
value: any;

  constructor(fb: FormBuilder) {
    this.fb = fb;
  }

  ngOnInit(): void {
    this.scheduleForm = this.fb.group({
      scheduleDate: [''],
      scheduleTime: ['']
    });
   
    const passedData = history.state.campaignData;

  if (passedData) {
    this.campaign = passedData;
    this.loadRecipients(); // Load recipients for the campaign
    // this.isLoading = false;
  } else {
    //  Fallback Flow: The user refreshed the page and broke the state!
    // Send them back to the list page so they can click it again.
    // alert('Session refreshed. Returning to campaign list.');
    this.router.navigate(['/campaign']);
  }

  }
   displayedColumns: string[] = ['name', 'email', 'phone', 'status'];
    //  contactsDs = new MatTableDataSource<listrecipients>([]);

  ngAfterViewInit(): void {
     this.contactsDs.paginator = this.paginator;
  }
  

 

  protected _sendNow(): void {
    if (!this.campaign || this.campaign.status.toLowerCase() !== 'draft') {
      // console.error('Campaign cannot be sent - invalid status');
      return;
    }
     const sendPayload = {
    id: this.campaign.id,
  };
//  console.log(' DATA READY TO SEND:', JSON.stringify(sendPayload, null, 2));

  // 5. Fire the API!
  this.campaignService.sendCampaign(sendPayload)
    .then((response) => {
      this.campaign!.status = 'processing'; 
      this.snackBarService.openSuccessSnackBar("Campaign sent successfully!");
      this.router.navigate(['/campaign']);
    })
    .catch((error) => console.error(error));
    
  }

  // 1. Controls the Button Text ('Schedule' vs 'Reschedule')
  get scheduleButtonText(): string {
    return this.campaign?.status?.toLowerCase() === 'scheduled' ? 'Re-Schedule' : 'Schedule';
  }

  // 2. Controls if the Button is Disabled
  get isScheduleButtonDisabled(): boolean {
    if (!this.campaign) return true;

    // If it hasn't been scheduled yet, the button is active!
    if (this.campaign.status?.toLowerCase() !== 'scheduled') {
      return false; 
    }

    // If it IS scheduled, calculate the time difference
    if (this.campaign.scheduledTime) {
      // Convert the backend string into a real Date object
      const scheduledDate = new Date(this.campaign.scheduledTime);
      const currentDate = new Date(); // Right now

      // Get the difference in milliseconds
      const timeDifferenceMs = scheduledDate.getTime() - currentDate.getTime();
      
      // 1 Hour = 60 minutes * 60 seconds * 1000 milliseconds
      const oneHourMs = 60 * 60 * 1000;

      // If the remaining time is less than or equal to 1 hour (or the time has already passed), DISABLE IT
      if (timeDifferenceMs <= oneHourMs) {
        return true;
      }
    }

    return false; // More than 1 hour away, allow reschedule!
  }

  protected _schedule(): void {
   const rawDate = this.scheduleForm.get('scheduleDate')?.value;
  const rawTime = this.scheduleForm.get('scheduleTime')?.value;

  // Safety check to ensure the user picked both
  if (!rawDate || !rawTime || !this.campaign?.id) {
    alert('Please select both a date and a time!');
    return;
  }

  // We take the Year/Month/Day from rawDate, and the Hours/Minutes from rawTime
  const combinedDateTime = new Date(
    rawDate.getFullYear(),
    rawDate.getMonth(),
    rawDate.getDate(),
    rawTime.getHours(),
    rawTime.getMinutes(),
    0 // Set seconds to zero
  );

 let exactLocalTime = formatDate(combinedDateTime, 'yyyy-MM-ddTHH:mm:ss', 'en-US');

  exactLocalTime = exactLocalTime + '.000Z';

  // 4. Build the payload
  const schedulePayload = {
    id: this.campaign.id,
    scheduledTime: exactLocalTime,
    status:'scheduled'
  };
  //  console.log(' DATA READY TO SEND:', JSON.stringify(schedulePayload, null, 2));

  // 5. Fire the API!
  this.campaignService.scheduleCampaign(schedulePayload)
    .then(() => {
      this.snackBarService.openSuccessSnackBar("Campaign scheduled successfully!");
      this.router.navigate(['/campaign']);
    })
    .catch((error) => console.error(error));
  }

  protected _cancelSchedule(): void {
    // 1. Safety check: prevent accidental clicks
    // const confirmCancel = confirm('Are you sure you want to cancel this scheduled campaign?');
    // if (!confirmCancel) {
    //   return; 
    // }

    const rightNow = new Date();
    const exactCancelTime = formatDate(rightNow, 'yyyy-MM-ddTHH:mm:ss', 'en-US') + '.000Z';

    // 2. Build the payload requested by the backend
    const cancelPayload = {
      id: this.campaign.id,
      scheduledTime: exactCancelTime, // Pass the original scheduled time back to the backend
      status: 'canceled' // Passing the status exactly as requested
    };

    this.campaignService.cancelCampaign(cancelPayload)
      .then(() => {
        this.snackBarService.openSuccessSnackBar("Campaign canceled successfully!");
        
        // Optional: Send them back to the list, or let them stay on the page
        this.router.navigate(['/campaign']); 
      })
      // .catch((error) => console.error('Failed to cancel schedule:', error));
  }

 protected _onSearchRecipients(event: Event): void {
    // 1. Grab the text
    const searchValue = (event.target as HTMLInputElement).value;
    
    // 2. Hand it directly to the table's built-in filter!
    // (Material automatically trims it and converts to lowercase under the hood)
    this.contactsDs.filter = searchValue.trim().toLowerCase();
  }
 async loadRecipients() {
    if (!this.campaign || !this.campaign.id) {
      return; // This stops the method from crashing the page
    }

    // 2. Build the exact payload
    const payload: ViewRecipientsPayload = {
      id: this.campaign.id 
    };

     // console.log(' Sending Payload:', payload);

    // 3. Call the API
    await this.campaignService.viewRecipients(payload)
      .then((apiResponse) => {
        this.contactsDs.data = apiResponse.responsedata; // Assuming the API returns { responsedata: [...] }
        this.allRecipients = apiResponse.responsedata;
      })
      .catch((error) => {
        // console.error(' Failed to load recipients API error:', error);
        this.snackBarService.openFailureSnackBar('Failed to load recipients. Please try again later.');
      });
  }

 protected _clearRecipientSearch(): void {
    // 1. Just reset the table back to the full list!
    this.contactsDs.data = this.allRecipients;
    
    // (If you are using the built-in Material filter, clear it like this too)
    this.contactsDs.filter = ''; 
  }

  protected getChannelIcon(channel: string): string {
    const icons: { [key: string]: string } = {
      'email': 'email',
      'whatsapp': 'chat',
    };
    return icons[channel] || 'mail';
  }
}

